import {Extension} from "@codemirror/state";
import {EditorView, hoverTooltip} from "@codemirror/view";
import {HoverEngine} from "../../../util/cafebabe/src/hover_engine";
import CodeStore from "../../../state/codeStore";

const hoverExtension = (codeStore: CodeStore): Extension => [
	hoverTooltip((view, pos, side) => {
		const project = codeStore.cafebabeProject;
		if (!project) return null;

		const hoverEngine = new HoverEngine();

		const start = pos,
			end = pos;

		const currFile = codeStore.focusedFile;
		if (!currFile) return null;

		project.updateFile(currFile, view.state.doc.toString());
		project.analyze();

		const expr = project.getFile(currFile)?.cu;
		if (!expr) return null;

		const info = hoverEngine.hoverAt(expr, pos);
		if (info.length === 0) return null;

		return {
			pos: start,
			end,
			above: true,
			create(_view: EditorView) {
				const dom = info[0]!.makeNode(_view);
				return {dom};
			},
		};
	}),
];

export default hoverExtension;
